import { React, george, pr, theme } from "aaa";

type IProps = {
    title?: string;
    content: React.ReactNode;
    style?: React.CSSProperties;
    error?: boolean;
};

export const ErrorBox = (props: IProps) => {
    const color = theme.themeColors.ui_red;
    return (
        <george.Card elevated={false} style={{ borderStyle: "solid", borderWidth: 1, borderColor: color, ...props.style }}>
            <pr.HFlex style={{ gap: 8, padding: 8, backgroundColor: "rgba(255, 0, 0, 0.1)" }}>
                <div>
                    <pr.IconMessageError style={{ color: color, width: 24, height: 24 }} />
                </div>
                <div>
                    {props.content}
                </div>
            </pr.HFlex>
        </george.Card>
    );
}



// WEBPACK FOOTER //
// ./src/components/common/ErrorBox.tsx